<template>
  <div class="page bg-white">
  
    <BindingMobile
     
      ref="bindingMobileRef"
      :telInput="telInput"
      :showChecked="true"
      @inputTelInfo="updTel"
    ></BindingMobile>
 <p class="note" >感谢您选择智云医道，请完成身份信息填写以便正常使用我们的服务</p>
 <p class="note" >如遇登录问题，如收不到验证码，可于工作时间9:00~18:00，联系客服电话19155592439</p>
    <van-button
      color="#1E8DFF"
      @click="bindMobile"
      class="submit-btn width-351"
      :disabled="!($util.isMobileValid(telInput.mobile) && $util.isMobileCodeValid(telInput.code))"
    
    >
      确定
    </van-button>

    
  </div>
</template>

<script>
import BindingMobile from '@/components/BindingMobile.vue';
import { mapMutations } from 'vuex';

export default {
  name: 'BindingMobilePage',
  components: {
   
    BindingMobile, 
  },
  data() {
    return {
     
      telInput: {
        mobile: '',
        code: ''
      },
      disableSubmit: false
    };
  },
  methods: {
    ...mapMutations(['updUserInfo']),
    updTel(data) {
      if (data.type == 'mobile') {
        this.telInput.mobile = data.value;
      }
      if (data.type == 'code') {
        this.telInput.code = data.value;
      }
    },
    bindMobile() {
      const checked = this.$refs.bindingMobileRef.checked;
      if (!checked) {
        this.$toast('请阅读并同意相关协议');
        return;
      }
      const { mobile, code } = this.telInput;
      const params = {
        mobile,
        verifyCode: code,
        verifyCodeType: 'BIND_PATIENT_MOBILE'
      };
      this.$fetch.updMobile(params).then((data) => {
        if (data.code == -102 || data.code == -107 || data.code == -106) {
          this.updUserInfo({ mobile });
          this.$router.go(-1)
        }  
      });
    }
  }
};
</script>

<style scoped lang="scss">
.page {
  position: relative;
  height: 100%;
  min-height: 500px;
  .submit-btn {
    height: 40px;
    border-radius: 40px;
    position: absolute;
    bottom: 32px;
    left: 0;
  }
}
.step-box {
  display: flex;
  justify-content: center;
  padding: 20px 60px 44px;
  align-items: baseline;
}
.circle {
  display: block;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 17px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  border: 1px solid rgba(204, 204, 204, 1);
  color: #cccccc;
  margin-left: 12px;
}
.text {
  font-size: 13px;
  font-weight: 400;
  color: rgba(204, 204, 204, 1);
  margin-top: 12px;
  display: inline-block;
  white-space: nowrap;
}

.active {
  .circle {
    background: rgba(73, 145, 253, 1);
    color: rgba(255, 255, 255, 1);
    border: 1px solid rgba(73, 145, 253, 1);
  }
  .text {
    color: #1e8dff;
  }
}
.dash-line {
  border-bottom: 1px dashed #ccc;
  width: 144px;
  margin-bottom: 10px;
  position: relative;
  top: -6px;
  left: 0;
}
.dash-line.active {
  border-bottom: 1px dashed #1e8dff;
}
.note {
  margin: 16px 12px 0;
  color: rgba(204, 204, 204, 1);
  line-height: 20px;
}
</style>
